const isEmpty = require('../../utils/lodash').default.isEmpty;
export default {
    namespaced: true,
    state: {
        data: {
            suppliers: [],
            currentPaymentSchemes: [],
            preferPaymentSchemes: [],
            usageUnits: [],
            usagePeriods: [],
            currentPropertyType: [],
            currentPropertySize: [],
            currentPropertyOwnership: [],
            currentEnergySource: [],
            currentEnergyBySameSupplier: [],
            currentEconomy7State: [],
            preferRenewableSources: [],
        },
        choice: {
            currentPropertyAddressPayload: null,
            currentPropertyRegion: null,
            currentPropertyMPRN: null,
            currentPropertyMPAN: null,
            currentPropertyType: null,
            currentPropertySize: null,
            currentPropertyOwnership: null,

            currentEnergySource: null,
            currentEnergyBySameSupplier: null,
            currentElectricitySupplier: null,
            currentElectricityTariff: null,
            currentEconomy7State: null,
            currentElectricityPaymentScheme: null,
            currentGasSupplier: null,
            currentGasTariff: null,
            currentGasPaymentScheme: null,
            currentWarmHomeState: null,

            averageElectricityUsageUnit: null,
            averageElectricityUsageStandardAmount: null,
            averageElectricityUsageDailyAmount: null,
            averageElectricityUsageNightlyAmount: null,
            averageElectricityUsagePeriod: null,
            averageGasUsageUnit: null,
            averageGasUsageAmount: null,
            averageGasUsagePeriod: null,
            preferPaymentScheme: null,
            preferRenewableSources: null,
        },
        address: null,
        estimate: null,
    },
    getters: {
        currentAddress: (state) => {
            return state.address;
        },
        isDataEmpty: (state) => {
            return !state.data.currentPropertyType.length
        },
        data: (state) => {
            return state.data
        },
        choice: (state) => {
            return state.choice
        },
        stepOneData: (state) => {
            return {
                currentPropertyAddress: state.data.currentPropertyAddress,
                currentPropertyType: state.data.currentPropertyType,
                currentPropertySize: state.data.currentPropertySize,
                currentPropertyOwnership: state.data.currentPropertyOwnership,
            }
        },
        stepTwoData: (state) => {
            return {
                currentEnergySource: state.data.currentEnergySource,
                currentEnergyBySameSupplier: state.data.currentEnergyBySameSupplier,
                suppliers: state.data.suppliers,
                currentEconomy7State: state.data.currentEconomy7State,
                currentPaymentSchemes: state.data.currentPaymentSchemes,
                currentWarmHomeState: state.data.currentWarmHomeState,
            }
        },
        stepThreeData: (state) => {
            return {
                usageUnits: state.data.usageUnits,
                usagePeriods: state.data.usagePeriods,
                preferRenewableSources: state.data.preferRenewableSources,
                preferPaymentSchemes: state.data.preferPaymentSchemes,
            }
        },
        hasAddress: (state) => {
            return !isEmpty(state.address);
        },
        estimate: (state) => {
            return state.estimate;
        },
        currentEnergySource: (state) => {
            return state.choice.currentEnergySource;
        },
        currentElectricityPaymentScheme: (state) => {
            return state.choice.currentElectricityPaymentScheme;
        },
        currentGasPaymentScheme: (state) => {
            return state.choice.currentGasPaymentScheme;
        },
        isUsingE7: (state) => {
            return state.choice.currentEconomy7State === "1"
        },
        currentAddressDecoded: (state) => {
            return JSON.parse(atob(state.choice.currentPropertyAddressPayload))
        }
    },
    mutations: {
        setData: (state, payload) => {
            Object.entries(payload).map(v => state.data[v[0]] = v[1]);
        },
        setSuppliers: (state, payload) => {
            state.data.suppliers = payload
        },
        setAddress: (state, payload) => {
            state.address = payload
            if(payload && payload.payload){
                state.choice.currentPropertyAddressPayload = payload.payload;
                state.choice.currentPropertyRegion = payload.region;
            }
        },
        setChoice: (state, payload) => {
            state.choice = payload;
        },
        setEstimate: (state, payload) => {
            state.estimate = payload;
        },
        clearChoice: (state) => {
            Object.entries(state.choice).map(v => state.choice[v[0]] = null);
        },
    },
}
